import React from 'react';

const steps = [
  {
    numeral: '1',
    title: 'Connect your knowledge',
    body: 'Upload PDFs, Word docs, and text — or crawl your wiki, SharePoint, Google Drive, and public site pages. Bring policies, playbooks, product specs, and FAQs into one place.',
  },
  {
    numeral: '2',
    title: 'Train your Company Brain',
    body: 'Chat.co indexes everything into a private knowledge base. Update a document once and every answer updates — no reprinting handbooks, no stale copies circulating.',
  },
  {
    numeral: '3',
    title: 'Give everyone access',
    body: 'Deploy inside your dashboard, embed on your intranet, or share with staff via SSO. Anyone on the team can ask in plain language and get a cited answer in seconds.',
  },
];

const HowItWorks: React.FC = () => (
  <section
    aria-label="How to build a company brain"
    className="border-y border-gray-100 bg-[#f6f8fb] py-16 sm:py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <div className="flex items-center gap-4">
          <span className="h-px w-10 bg-primary-600/50" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.24em] text-primary-600">
            How it works
          </span>
        </div>
        <h2 className="mt-5 text-3xl font-bold leading-tight tracking-tight text-gray-900 sm:text-[2.6rem] sm:leading-[1.15]">
          From scattered files to a living brain{' '}
          <span className="font-display font-medium italic text-primary-600">in three steps.</span>
        </h2>
      </div>

      <div className="mt-12 divide-y divide-gray-200/80 overflow-hidden rounded-[28px] border border-gray-100 bg-white">
        {steps.map((step) => (
          <div
            key={step.numeral}
            className="group grid gap-6 px-6 py-9 transition-colors duration-300 hover:bg-[#f8fafc] sm:grid-cols-12 sm:gap-8 sm:px-8">
            <div className="sm:col-span-2">
              <span className="font-display text-6xl font-light italic leading-none text-gray-200 transition-colors duration-300 group-hover:text-primary-600/40 sm:text-7xl">
                {step.numeral}
              </span>
            </div>
            <div className="sm:col-span-4">
              <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
            </div>
            <div className="sm:col-span-6">
              <p className="text-[15px] leading-relaxed text-gray-500">{step.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
